module.exports = __webpack_public_path__ + "img/result-icon-grey.ed1b1de2.png";